/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * list the accounts
 * @returns 
 */
export const list = async (params = []) => {

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'get',
            url: getEndpoint('/accounts', params),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

export const find = async (params = []) => {

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'get',
            url: getEndpoint('/accounts/find', params),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get an account
 * @returns 
 */
export const show = async (account_id = null) => {

    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'account_id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/accounts/'+account_id),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

export const users = async (account_id, params = []) => {
    
    const url = getEndpoint('/accounts/' + account_id + '/users', params)

    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url,
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * create a new account
 * @returns
 */
export const create = async data => {

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/accounts'),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get an account
 * @returns
 */
export const update = async (account_id = null, data) => {

    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'account_id is required'})

        axios({
            method: 'patch',
            url: getEndpoint('/accounts/'+account_id),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the locations associated to a specific auctioneer
 * @param account_id
 * @returns {Promise<unknown>}
 */
export const locations = async account_id => {

    return new Promise(( resolve, reject ) => {

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/accounts/'+account_id+'/locations'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the locations associated to a specific account
 * @param account_id
 * @returns {Promise<unknown>}
 */
export const createLocation = async (account_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/accounts/'+account_id+'/locations'),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the locations associated to a specific account
 * @param account_id
 * @returns {Promise<unknown>}
 */
export const updateLocation = async (account_id, location_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        if (!location_id) {
            reject({message: 'location_id missing'})
            return
        }

        axios({
            method: 'patch',
            url: getEndpoint('/accounts/'+account_id+'/locations/'+location_id),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const assignLocation = async (account_id, location_id) => {

    return new Promise(( resolve, reject ) => {

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        if (!location_id) {
            reject({message: 'location_id missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/accounts/'+account_id+'/locations/'+location_id+'/assign'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const upsertLogo = async (account_id, data) => {
    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'The account_id is required'})

        let formData = new FormData()
        for (let key in data) {
            formData.append(key, data[key])
        }

        axios({
            method: 'post',
            url: getEndpoint('/accounts/'+account_id+'/logo'),
            data: formData,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })

}

export const listAliases = async (account_id) => {
    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'The account_id is required'})

        axios({
            method: 'get',
            url: getEndpoint('/accounts/'+account_id+'/aliases'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })

}

export const updateAlias = async (account_id, alias_id, data) => {
    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'The account_id is required'})

        if (!alias_id) return reject({ message: 'The alias_id is required'})

        axios({
            method: 'patch',
            url: getEndpoint('/accounts/'+account_id+'/aliases/'+alias_id),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })

}

export const deleteAlias = async (account_id, alias_id) => {
    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'The account_id is required'})

        if (!alias_id) return reject({ message: 'The alias_id is required'})

        axios({
            method: 'delete',
            url: getEndpoint('/accounts/'+account_id+'/aliases/'+alias_id),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })

}

export const createAlias = async (account_id, data) => {
    return new Promise(( resolve, reject ) => {

        if (!account_id) return reject({ message: 'The account_id is required'})

        axios({
            method: 'post',
            url: getEndpoint('/accounts/'+account_id+'/aliases'),
            data,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })

}

export const addSeller = async (account_id, data) => {

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/accounts/'+account_id+'/seller'),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const addBuyer = async (account_id, data) => {

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/accounts/'+account_id+'/buyer'),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}